import React from 'react';
import Loadable from 'react-loadable';

const prefix = '/';

function Loading() {
    return <div id="cover-spin"></div>;
}

const Home = Loadable({
    loader: () => import('./pages/HomePage'),
    loading: Loading,
});

const Product = Loadable({
    loader: () => import('./pages/ProductPage/ProductPage'),
    loading: Loading,
});

const Order = Loadable({
    loader: () => import('./pages/OrderPage'),
    loading: Loading,
});

const ProductList = Loadable({
    loader: () => import('./pages/ProductPage/ProductListPage'),
    loading: Loading,
});

const ProductDetail = Loadable({
    loader: () => import('./pages/ProductPage/ProductDetailPage'),
    loading: Loading,
});


////////////////////////////////////////////////////////////
// then our route config
const routes = [
    {
        path: `${prefix}`,
        name: "Halaman Depan",
        component: Home,
        exact: true
    },
    {
        path: `${prefix}order`,
        name: "Order",
        component: Order
    },
    {
        path: `${prefix}produk`,
        name: "Produk",
        component: Product,
        routes : [
            {
                path: `${prefix}produk`,
                name: "Daftar Produk",
                component: ProductList,
                icon : "fa fa-twitch",
                exact: true
            },
            {
                path: `${prefix}produk/:productId`,
                name: "Detail Produk",
                component: ProductDetail,
                icon : "fa fa-twitch"
            }
        ]
    }
];

export default routes;


// WEBPACK FOOTER //
// ./src/routes.js